import React, { useMemo, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useAuth } from "../Context/AuthContext";
import { ApiEndpoint } from "../utils/ApiEndpoint";

import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import { httpClient } from "../utils/HttpClient";
import PropTypes from "prop-types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
import { useQuery } from "@tanstack/react-query";
import Graph from "../utils/classes/graph";
import moment from "moment";
import GraphSkeleton from "./ui/Skeleton/GraphSkeleton";

export function SmsByDateGraph(props) {
  const { onChangeDate } = props;
  const Auth = useAuth();
  const channel = Auth.getUserChannel();
  const { uid_partner, uid_user, token } = Auth.getSessionData();
  const [filterType, setFilterType] = useState(0);

  const { isFetching: isPending, data: chartData } = useQuery({
    queryKey: ["homeSmsByDate", filterType],
    queryFn: async () => {
      const initDate = moment().startOf("month").format("YYYY/MM/DD");
      const dateReport = new Date();
      dateReport.setDate(dateReport.getDate() - filterType);
      const from =
        filterType === 0 ? initDate : moment(dateReport).format("YYYY/MM/DD");
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}reports/getMessagesByDay`,
        {
          uidpartner: uid_partner,
          from: from,
          user: uid_user,
        },
        token
      );

      return await response.data;
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const { dataReport1, dataCategories } = useMemo(() => {
    if (!chartData) return;

    const Resolver = new Graph(chartData, channel);
    const dataReport1 = Resolver.generate();
    const dataCategories = Resolver.uniqueDays();

    return {
      dataReport1,
      dataCategories,
    };
  }, [chartData]);

  const dataGraph = {
    labels: dataCategories || [],
    datasets: [
      {
        type: "bar",
        label: "SMS por Día",
        data: dataReport1.map((item) => item.sms) || [],
        borderColor: "#a5f3fc",
        backgroundColor: "#a5f3fc",
        borderWidth: 1,
      },
      {
        type: "line",
        label: "Total por Día",
        data: dataReport1.map((item) => item.subtotal) || [],

        backgroundColor: "#019CFF",
        borderColor: "#019CFF",
        borderWidth: 2,
        fill: false,
        tension: 0.3,
      },
      {
        type: "bar",
        label: "RCS por Día",
        data: dataReport1.map((item) => item.rcs) || [],
        backgroundColor: "#c7d2fe",
        borderColor: "#c7d2fe",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "SMS por Dia",
      },
    },
  };

  const handleDate = (value) => {
    setFilterType(value);
    onChangeDate(value);
  };

  if (isPending)
    return (
      <div className="px-4 py-1.5 w-full h-full bg-white rounded-lg">
        <GraphSkeleton />
      </div>
    );
  return (
    <>
      <div style={{ height: "300px", width: "100%" }}>
        <div>
          <ButtonToolbar className="justify-content-between Bar chartToolBar">
            <h6>SMS por periodo</h6>
            <ButtonGroup aria-label="First group" size="sm">
              <Button
                variant={filterType == 0 ? "primary" : "outline-secondary"}
                onClick={() => {
                  handleDate(0);
                }}
              >
                Mes Actual
              </Button>
              <Button
                variant={filterType == 30 ? "primary" : "outline-secondary"}
                onClick={() => {
                  handleDate(30);
                }}
              >
                30 días
              </Button>
              <Button
                variant={filterType == 90 ? "primary" : "outline-secondary"}
                onClick={() => {
                  handleDate(90);
                }}
              >
                90 días
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </div>
        <div className="px-4 py-1.5 w-full h-full bg-white rounded-lg">
          <Line options={options} data={dataGraph} />
        </div>
      </div>
    </>
  );
}
SmsByDateGraph.propTypes = {
  onChangeDate: PropTypes.func,
};
export default SmsByDateGraph;
